export const termsContent = {
  en: {
    title: "Terms and Conditions",
    lastUpdated: "Last updated: March 16, 2025",
    sections: [
      {
        title: "Introduction",
        content: "These Terms and Conditions (\"Terms\") govern your access to and use of our website. By accessing or using our website, you agree to be bound by these Terms. If you disagree with any part of these Terms, then you may not access our website."
      },
      {
        title: "Intellectual Property",
        content: "The website and its original content, features, and functionality are and will remain the exclusive property of EZseat and its licensors. The website is protected by copyright, trademark, and other laws of both Thailand and foreign countries. Our trademarks and trade dress may not be used in connection with any product or service without the prior written consent of EZseat."
      },
      {
        title: "User Representations",
        content: "By using our website, you represent and warrant that:",
        list: [
          "You have the legal capacity and agree to comply with these Terms.",
          "You will not use the website for any illegal or unauthorized purpose.",
          "Your use of the website will not violate any applicable law or regulation."
        ]
      },
      {
        title: "Prohibited Activities",
        content: "You may not access or use the website for any purpose other than that for which we make the website available. The website may not be used in connection with any commercial endeavors except those that are specifically endorsed or approved by us."
      },
      {
        title: "Links to Other Websites",
        content: "Our website may contain links to third-party websites or services that are not owned or controlled by us. We have no control over, and assume no responsibility for, the content, privacy policies, or practices of any third-party websites or services. You further acknowledge and agree that we shall not be responsible or liable, directly or indirectly, for any damage or loss caused or alleged to be caused by or in connection with the use of or reliance on any such content, goods, or services available on or through any such websites or services."
      },
      {
        title: "Termination",
        content: "We may terminate or suspend your access to our website immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach these Terms. Upon termination, your right to use the website will immediately cease."
      },
      {
        title: "Disclaimer",
        content: "The website is provided on an \"AS IS\" and \"AS AVAILABLE\" basis. We disclaim all warranties of any kind, whether express or implied, including but not limited to the implied warranties of merchantability, fitness for a particular purpose, and non-infringement."
      },
      {
        title: "Limitation of Liability",
        content: "In no event shall we be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from your access to or use of or inability to access or use the website."
      },
      {
        title: "Governing Law",
        content: "These Terms shall be governed and construed in accordance with the laws of Thailand, without regard to its conflict of law provisions."
      },
      {
        title: "Changes to Terms",
        content: "We reserve the right, at our sole discretion, to modify or replace these Terms at any time. By continuing to access or use our website after those revisions become effective, you agree to be bound by the revised terms."
      },
      {
        title: "Contact Information",
        content: "If you have any questions about these Terms, please contact us at: info@thairoute.com"
      }
    ]
  },
  th: {
    title: "ข้อกำหนดและเงื่อนไข",
    lastUpdated: "อัปเดตล่าสุด: 16 มีนาคม 2568",
    sections: [
      {
        title: "บทนำ",
        content: "ข้อกำหนดและเงื่อนไขเหล่านี้ (\"ข้อกำหนด\") ควบคุมการเข้าถึงและการใช้เว็บไซต์ของเรา โดยการเข้าถึงหรือใช้เว็บไซต์ของเรา คุณตกลงที่จะผูกพันตามข้อกำหนดเหล่านี้ หากคุณไม่เห็นด้วยกับส่วนใดของข้อกำหนดเหล่านี้ คุณไม่ควรเข้าถึงเว็บไซต์ของเรา"
      },
      {
        title: "ทรัพย์สินทางปัญญา",
        content: "เว็บไซต์และเนื้อหาดั้งเดิม คุณสมบัติ และฟังก์ชันการทำงานเป็นและจะยังคงเป็นทรัพย์สินเฉพาะของ EZseat และผู้อนุญาตให้ใช้สิทธิ์ เว็บไซต์ได้รับการคุ้มครองโดยลิขสิทธิ์ เครื่องหมายการค้า และกฎหมายอื่นๆ ทั้งของประเทศไทยและประเทศอื่นๆ เครื่องหมายการค้าและการแต่งกายทางการค้าของเราไม่สามารถใช้ในการเชื่อมโยงกับผลิตภัณฑ์หรือบริการใดๆ โดยไม่ได้รับความยินยอมเป็นลายลักษณ์อักษรล่วงหน้าจาก EZseat"
      },
      {
        title: "การรับรองของผู้ใช้",
        content: "โดยการใช้เว็บไซต์ของเรา คุณรับรองและรับประกันว่า:",
        list: [
          "คุณมีความสามารถทางกฎหมายและตกลงที่จะปฏิบัติตามข้อกำหนดเหล่านี้",
          "คุณจะไม่ใช้เว็บไซต์เพื่อวัตถุประสงค์ที่ผิดกฎหมายหรือไม่ได้รับอนุญาต",
          "การใช้เว็บไซต์ของคุณจะไม่ละเมิดกฎหมายหรือข้อบังคับที่บังคับใช้"
        ]
      },
      {
        title: "กิจกรรมที่ห้าม",
        content: "คุณไม่สามารถเข้าถึงหรือใช้เว็บไซต์เพื่อวัตถุประสงค์อื่นนอกเหนือจากที่เราสร้างเว็บไซต์ขึ้นมา เว็บไซต์ไม่สามารถใช้ในการเชื่อมโยงกับความพยายามทางการค้าใดๆ ยกเว้นสิ่งที่ได้รับการรับรองหรืออนุมัติโดยเฉพาะจากเรา"
      },
      {
        title: "ลิงก์ไปยังเว็บไซต์อื่น",
        content: "เว็บไซต์ของเราอาจมีลิงก์ไปยังเว็บไซต์หรือบริการของบุคคลที่สามที่ไม่ได้เป็นเจ้าของหรือควบคุมโดยเรา เราไม่มีการควบคุมและไม่รับผิดชอบต่อเนื้อหา นโยบายความเป็นส่วนตัว หรือแนวปฏิบัติของเว็บไซต์หรือบริการของบุคคลที่สามใดๆ คุณยอมรับและตกลงว่าเราจะไม่รับผิดชอบหรือรับผิด ไม่ว่าโดยตรงหรือโดยอ้อม สำหรับความเสียหายหรือการสูญเสียใดๆ ที่เกิดขึ้นหรือถูกกล่าวหาว่าเกิดขึ้นโดยหรือในการเชื่อมโยงกับการใช้หรือการพึ่งพาเนื้อหา สินค้า หรือบริการดังกล่าวที่มีอยู่บนหรือผ่านเว็บไซต์หรือบริการดังกล่าว"
      },
      {
        title: "การยกเลิก",
        content: "เราอาจยกเลิกหรือระงับการเข้าถึงเว็บไซต์ของเราทันที โดยไม่ต้องแจ้งให้ทราบล่วงหน้าหรือความรับผิด ไม่ว่าด้วยเหตุผลใดก็ตาม รวมถึงแต่ไม่จำกัดเพียงหากคุณละเมิดข้อกำหนดเหล่านี้ เมื่อมีการยกเลิก สิทธิ์ของคุณในการใช้เว็บไซต์จะสิ้นสุดลงทันที"
      },
      {
        title: "ข้อสงวนสิทธิ์",
        content: "เว็บไซต์นี้จัดเตรียมขึ้นบนพื้นฐาน \"ตามที่เป็น\" และ \"ตามที่มีให้\" เราปฏิเสธการรับประกันทุกประเภท ไม่ว่าจะโดยชัดแจ้งหรือโดยนัย รวมถึงแต่ไม่จำกัดเพียงการรับประกันโดยนัยของความสามารถในการขาย ความเหมาะสมสำหรับวัตถุประสงค์เฉพาะ และการไม่ละเมิด"
      },
      {
        title: "การจำกัดความรับผิด",
        content: "ไม่ว่ากรณีใดๆ เราจะไม่รับผิดต่อความเสียหายทางอ้อม อุบัติเหตุ พิเศษ ผลสืบเนื่อง หรือเชิงลงโทษ รวมถึงแต่ไม่จำกัดเพียง การสูญเสียกำไร ข้อมูล การใช้งาน ความนิยม หรือการสูญเสียที่ไม่มีตัวตนอื่นๆ อันเป็นผลมาจากการเข้าถึงหรือการใช้หรือไม่สามารถเข้าถึงหรือใช้เว็บไซต์"
      },
      {
        title: "กฎหมายที่ใช้บังคับ",
        content: "ข้อกำหนดเหล่านี้จะถูกควบคุมและตีความตามกฎหมายของประเทศไทย โดยไม่คำนึงถึงข้อขัดแย้งของข้อกำหนดกฎหมาย"
      },
      {
        title: "การเปลี่ยนแปลงข้อกำหนด",
        content: "เราขอสงวนสิทธิ์ ตามดุลยพินิจของเราแต่เพียงผู้เดียว ในการแก้ไขหรือแทนที่ข้อกำหนดเหล่านี้เมื่อใดก็ได้ โดยการเข้าถึงหรือใช้เว็บไซต์ของเราต่อไปหลังจากการแก้ไขเหล่านั้นมีผล คุณตกลงที่จะผูกพันตามข้อกำหนดที่แก้ไข"
      },
      {
        title: "ข้อมูลติดต่อ",
        content: "หากคุณมีคำถามใดๆ เกี่ยวกับข้อกำหนดเหล่านี้ โปรดติดต่อเราที่: info@thairoute.com"
      }
    ]
  }
};
